import React, { useEffect, useState } from "react";
import { FaDesktop } from "react-icons/fa"; // Screen icon
import { FaUser } from "react-icons/fa"; // User icon
import { IoAlert } from "react-icons/io5"; // Alert icon
import "./style.css";
import { useStores } from "../../../store";

const ScreenShareErrorCard = ({ text, icon, timer, show }) => {
  const [showContainer, setShowContainer] = useState(false);
  const [visible, setVisible] = useState(true);
  const [elapsedTime, setElapsedTime] = useState(0);
  const { InterviewStore } = useStores();

  useEffect(() => {
    // Show the notification bar after a delay
    const showTimer = setTimeout(() => {
      setShowContainer(true);
    }, 200);

    // Start the timer when the component is shown
    const timerInterval = setInterval(() => {
      setElapsedTime((prevTime) => prevTime + 1);
    }, 1000);

    // Hide the notification after 5 seconds
    const hideTimer = setTimeout(() => {
      InterviewStore.setShowNotification(false);
      InterviewStore.setNotificationTimer(false);
      InterviewStore.setMicNotification(false);
      InterviewStore.setCameraNotification(false);
      setVisible(false);
      clearInterval(timerInterval); // Stop the timer when hidden
    }, 3000); // 500ms (initial delay) + 5000ms (visible duration)

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      clearInterval(timerInterval); // Clean up the timer
    };
  }, [visible]);

  // Format elapsed time into MM:SS
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (time % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  if (!visible) {
    return null; // Do not render anything if not visible
  }

  return (
    <div className=" z-50 w-full  absolute">
      <div
        className={`animated-div  transition-all z-50 duration-1000 ease-out ${
          showContainer
            ? "expanded pl-3 pr-3 flex gap-3 md:!w-[22vw] items-center justify-between"
            : "flex items-center justify-center md:!w-14"
        } mx-auto mt-5 bg-black rounded-3xl h-12 md:w-5`}
      >
        <div
          className={`text-container overflow-hidden z-50 transition-all duration-1000 ease-out ${
            showContainer ? "w-full flex flex-col items-start " : "w-0"
          }`}
        >
          {/* Timer Section */}
          {/* {timer &&<div className={`${text.toLowerCase().includes('off')?"text-[#FA3532]":""} flex items-center z-50 gap-2 text-white`}>
            <span className={`w-2 h-2 ${text.toLowerCase().includes('off')?"bg-[#FA3532]":"bg-white"}  rounded-full`}></span>
            <span className="text-sm">{formatTime(elapsedTime)}</span>
          </div>} */}

          {/* Text Section */}
          <h1
            className={` ${
              text === "Interview Completed Successfully"
                ? "text-[#37C058]"
                : text === "Interview Stopped"
                ? "text-[#FA3532]"
                : "text-primary"
            } whitespace-nowrap z-50 gil-med`}
          >
            {text || "Unable to access the Screen Share"}
          </h1>
        </div>
        <div
          className={` ${
            text === "Interview Completed Successfully"
              ? ""
              : text === "Interview Stopped"
              ? ""
              : "bg-primary p-2"
          }   rounded-full w-8 z-50 transition-all duration-1000 ease-out`}
        >
          {icon || (
            <div className="relative text-white bg-primary">
              <FaDesktop className="text-sm" />
              <FaUser className="text-[8px] absolute bottom-0 right-0" />
              <IoAlert className="text-[10px] absolute top-0 right-1" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScreenShareErrorCard;
